<template>
  <div style="display: flex; align-items: center; justify-content: center">
    <a-empty />
  </div>
</template>